






import { Component, Prop, Vue } from 'vue-property-decorator'

import tinymce from 'tinymce'

import 'tinymce/themes/silver/theme.min.js'
import 'tinymce/icons/default/icons'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/codesample'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/media'
import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/hr'
import 'tinymce/plugins/paste'

import Editor from '@tinymce/tinymce-vue'

@Component({ name: 'TinymceEditor', components: { Editor } })
export default class extends Vue {

    @Prop({ default: 350 }) height!: number
    @Prop({ default: '' }) content!: string

    // ���ı���ֵ
    private value: string = ''

    // ���ı���init����
    private get init() {
        return {
            selector: '#tinymce',
            language_url: '/tinymce/langs/zh_CN.js',
            language: 'zh_CN',
            skin_url: '/tinymce/skins/ui/oxide',
            height: this.height,
            branding: false,
            plugins:
                'link lists image codesample code table wordcount  media table fullscreen preview pagebreak insertdatetime hr paste', // ���
            toolbar:
                'codesample image bold italic underline alignleft aligncenter alignright alignjustify | forecolor backcolor | fontselect | fontsizeselect | formatselect |  bullist numlist | outdent indent blockquote | removeformat| undo redo | link unlink media insertdatetime table  hr pagebreak | fullscreen preview | strikethrough', // ������
            font_formats: 'Arial=arial,helvetica,sans-serif; ����=SimSun;  ΢���ź�=Microsoft Yahei; Impact=impact,chicago;', // ����
            fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px 64px 72px', // ���ִ�С
            paste_data_images: true,
            codesample_languages: [
                { text: 'HTML/XML', value: 'markup' },
                { text: 'JavaScript', value: 'javascript' },
                { text: 'CSS', value: 'css' },
                { text: 'Java', value: 'java' },
                { text: 'C++', value: 'cpp' },
            ],
            // ͼƬ�ϴ��ص�
            images_upload_handler: (blobInfo: any, success: Function, failure: Function) => {
                let formData = new FormData()
                console.log(blobInfo.filename())
                formData.append('files', blobInfo.blob())
                let url = this.$apis.image();
                this.$https.post(url, formData)
                    .then((res: any) => {
                        success("https://localhost:9999" + res.data);
                    });
            },
        }
    }

    mounted() {
        tinymce.init({})
        this.value = this.content
    }

    onEditorInput(e: any) {
        this.$emit('input', this.value)
    }

    setContent(str: any) {
        this.value = str
    }
}
